// extracted by mini-css-extract-plugin
export default {"input":"pricingInfo_input__vonZu","span":"pricingInfo_span__jQNtB"};